export const FILE_TYPES = {
    msoffice: ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'],
    images: [
        'jpg',
        'jpeg',
        'png',
        'gif',
        'svg',
        'apng',
        'avif',
        'jfif',
        'webp',
        'pjpeg',
        'pjp',
        'bmp',
        'tiff',
        'tif'
    ],
    video: [
        '3g2',
        '3gp',
        'avi',
        'flv',
        'h264',
        'm4v',
        'mkv',
        'mov',
        'mp4',
        'mpeg',
        'mpg',
        'webm',
        'wmv'
    ],
    audio: [
        'aac',
        'aif',
        'cda',
        'flac',
        'm4a',
        'mid',
        'midi',
        'mp3',
        'mpga',
        'oga',
        'ogg',
        'wav'
    ],
    text: ['txt', 'text', 'json', 'xml', 'html', 'xhtml', 'htm', 'md'],
    compressed: ['7z', 'arj', 'deb', 'pkg', 'rar', 'rpm', 'gz', 'z', 'zip']
};
//# sourceMappingURL=fileTypes.js.map